import React from 'react';
import CouponsList from 'containers/Coupons/CouponsList';

const CouponsListPage = () => <CouponsList />;

export default CouponsListPage;
